module.exports = __webpack_public_path__ + "img/20260916_daimuzhi.e6c94dab.jpg";